import React, { Component } from "react";
import {Modal, Button, FormGroup, FormControl, ControlLabel, Grid, Row, Col, Image, Checkbox } from "react-bootstrap";
import Loading from "../../components/loading";

import styles from "./style.css";
import UsersService from "../../services/users-service";
import ClientService from '../../services/client-service';
import EmailService from "../../services/email-service";

import {ToastContainer, ToastStore} from 'react-toasts';

class Login extends Component {

    constructor(props, context) {
        super(props, context);

        this.handleChange = this.handleChange.bind(this);
        this.renderLoadingModal = this.renderLoadingModal.bind(this);
        this.sendEmail = this.sendEmail.bind(this);

        this.state = {
            license: "",
            username: "",
            password: "",
            isLoggingIn: false,//for loading modal
            rememberMe: UsersService.sharedInstance.getRememberMeValue(),
            showLoginIcons: false,
            incorrectLicense: true,
            incorrectUsername: false,
            incorrectPassword: true,
            showRestoreModal: false,
        };

        if(this.state.rememberMe){
            let loginData = UsersService.sharedInstance.getStoredCredentials();
            this.state.username = loginData.username;
            this.state.license = loginData.license;
            this.state.rememberMe = loginData.rememberMe;
            this.state.password = loginData.password;
        }
    }

    componentDidMount() {

        //this.props.pageChange("Settings", {dude: "hello po"});//For Testing, forced next page

    }

    validateForm() {
        return this.state.username.length > 0 && this.state.password.length > 0;
    }

    handleChange = event => {

        var value = event.target.value;

        if(event.target.id == "rememberMe"){
            value = !this.state.rememberMe;
        }

        this.setState({
            [event.target.id]: value
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        const that = this;
        this.setState({
            isLoggingIn: true,
        });

        UsersService.sharedInstance.signInWithCredentials(this.state.license, this.state.username, this.state.password)
        .then((response)=>{
            this.setState({
                isLoggingIn: false,
            });
            if (response.success == 1) {

                const permission_info = UsersService.sharedInstance.returnEmptyIfNull(response.permission_info);

                let page = 'Settings';


                if(permission_info){
                    const permission = JSON.parse(permission_info);
                    const keys = Object.keys(page);
                    //page = keys[0];
                    page="Incidents"; //assumme all license has incidents
                    response.permission = permission;
                }

                UsersService.sharedInstance.storeLoggedInCredentials(
                    response.user_type.recno, 
                    that.state.username, 
                    that.state.license, 
                    response.token_data, 
                    that.state.rememberMe, 
                    that.state.password, 
                    response
                );

                that.props.setLoggedInUser({
                    username: that.state.username, 
                    license:that.state.license, 
                    token: response.token_data.token
                });

                that.props.pageChange(page, response);
            }else {
                this.setState({
                    isLoggingIn: false,
                    showLoginIcons: true,
                    incorrectLicense: response.invalid.license,
                    incorrectUsername: response.invalid.username,
                    incorrectPassword: response.invalid.password,
                });

                ToastStore.error("Incorrect Login Details");

            }
        }).catch((error)=>{
            this.setState({
                isLoggingIn: false,
            });
        });
    }

    render() {
               return(
            <div>
                <div className="main_container">
                    <div className="show-grid login_row">
                        <div className="logo_div">
                                <Image src={require('../../assets/login_logo.png')} className="csa_logo"/>

                                <h1 className="csa_text">CSA360</h1>
                                <h3 className="csa_subtext">Dynamic Security Signal Measurement Platform</h3>
                                <h5 className="footer">Archon Tech Strategies <br/> 2019 <br/> v.1.0.0</h5>
                        </div>
                        <div className="login_form_div">
                            <div className="login">
                                <h1 className="login_text">LOGIN</h1>
                                <ToastContainer  position={ToastContainer.POSITION.TOP_CENTER} store={ToastStore}/>
                                <form onSubmit={this.handleSubmit} className="login_form">
                                    <FormGroup controlId="license" bsSize="large">
                                        <ControlLabel className="login_label">License</ControlLabel>
                                        <FormControl
                                            autoFocus
                                            type="text"
                                            value={this.state.license}
                                            onChange={this.handleChange}
                                        />
                                    </FormGroup>
                                    {this.renderLoginIcon('license')}
                                    <FormGroup controlId="username" bsSize="large">
                                        <ControlLabel className="login_label">User Name</ControlLabel>
                                        <FormControl
                                            type="text"
                                            value={this.state.username}
                                            onChange={this.handleChange}
                                        />
                                    </FormGroup>
                                    {this.renderLoginIcon('username')}
                                    <FormGroup controlId="password" bsSize="large">
                                        <ControlLabel className="login_label">Password</ControlLabel>
                                        <FormControl
                                            value={this.state.password}
                                            onChange={this.handleChange}
                                            type="password"
                                        />
                                    </FormGroup>
                                    {this.renderLoginIcon('password')}

                                    <FormGroup>
                                        <Checkbox id="rememberMe" onChange={this.handleChange} checked={this.state.rememberMe}>Remember my credentials on this device</Checkbox>
                                    </FormGroup>
                                    <Button
                                        block
                                        bsSize="large"
                                        disabled={!this.validateForm()}
                                        type="submit"
                                        bsStyle="primary"
                                        className="login_button">
                                        Login
                                    </Button>
                                </form>

                                <Button bsStyle="link" onClick={()=> {this.setState({showRestoreModal: true})}}>Forgot password or License Number? </Button>

                            </div>
                        </div>
                    </div>
                </div>

                <Modal 
                    style={{marginTop: "10%", textAlign: "center"}}
					show={this.state.showRestoreModal}
                    onExit={()=>{this.setState({showRestoreModal: false})}}>
                    
                    <Modal.Header>
                      	<b style={{fontSize: 20}}>Receive Credentials</b>
                    </Modal.Header>
                    <Modal.Body>
                        <FormGroup controlId="userEmail">
                            <ControlLabel className="login_label">Email Address:</ControlLabel>
                            <FormControl
                                type="text"
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Button className="red-btn" onClick={()=> {this.setState({showRestoreModal: false})}}>Cancel</Button>
						    <Button className="blue-btn" onClick={this.sendEmail}>SEND</Button>
					    </FormGroup>
                    </Modal.Body>
                </Modal>

                { <Loading isShowing={this.state.isLoggingIn} message="Logging In. . ."/>}
            </div>
        );
    }

    renderLoginIcon(field){

        var correctStatus = true;

        if (this.state.showLoginIcons == false){
            return;
        }

        switch(field){
            case 'license':
                correctStatus = this.state.incorrectLicense == true ? false : true;
                break;
            case 'username':
                correctStatus = this.state.incorrectUsername == true ? false : true;
                break;
            case 'password':
                correctStatus = this.state.incorrectPassword == true ? false : true;
                break;
            default:
                //
        }

        if (correctStatus){
            return (
                <div className="login-icon"><Image src={require('../../assets/checkmark.png')} height={30} width={30}/></div>
            )
        } else {
            return (
                <div className="login-icon"><Image src={require('../../assets/warning.png')} height={30} width={30}/></div>
            )
        }
    }

    handleChange = event => {
        var value = event.target.value;

        this.setState({
            [event.target.id]: value,
            hasChanged: true,
        });
    }

    sendEmail(){
        let params = {
            "email": this.state.userEmail
        }

        EmailService.sharedInstance.sendUserCredentials(params)
        .then((response)=>{
            if (response){
                ToastStore.success("Successfully Sent Your Credentials to your email!");
                this.setState({showRestoreModal: false});
            }
            else {
                ToastStore.error("Email not found in our system!");
            }
        })
    }

    renderLoadingModal() {

    }
}

export default Login;
